/** @format */

import { Component, inject, input } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconChevronLeft,
	homefieldIconChevronRight,
	homefieldIconSignCircle
} from '@dsg-tech/homefield-angular-icons';
import { HomrWireSpotCarouselSlide, IHomrRichContent } from '@shared/data-access/interfaces';
import { SharedUtilsPipesModule, UriDecodePipe } from '@shared/utils/pipes';

import { CommonModule } from '@angular/common';
import { DCSG_CONSTANTS } from '@shared/data-access/constants';
import { HmfCarouselComponent } from '@dsg-tech/homefield-angular-cdk';
import { Observable } from 'rxjs';
import { Store, UtilityService } from '@shared/data-access/services';

import { map } from 'rxjs/operators';

@Component({
	selector: 'pdp-homr-wire-spot',
	templateUrl: './homr-wire-spot.component.html',
	styleUrls: ['./homr-wire-spot.component.scss'],
	imports: [
		CommonModule,
		HmfCarouselComponent,
		HomefieldIconLibraryModule,
		SharedUtilsPipesModule
	]
})
export class HomrWireSpotComponent {
	readonly lazyLoadImages = input(false);
	enhancedProductCardContent$: Observable<HomrWireSpotCarouselSlide[]>;
	slideAmount$: Observable<number>;
	fallbackImage = DCSG_CONSTANTS.imageUnavailable;
	currentSlideIndex = 1;
	decodeURIPipe = new UriDecodePipe();

	private readonly store = inject(Store);
	readonly utilityService = inject(UtilityService);
	readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconChevronRight,
			homefieldIconChevronLeft,
			homefieldIconSignCircle
		]);

		this.enhancedProductCardContent$ = this.store
			.selectDistinctKey('HOMR_DATA')
			.pipe(
				map(
					(data: { homrRichContent: IHomrRichContent }) =>
						data.homrRichContent.enhancedProductCard
				)
			);

		this.slideAmount$ = this.enhancedProductCardContent$.pipe(map((content) => content.length));
	}

	trackBySlide(index: number, item: HomrWireSpotCarouselSlide): string {
		return index.toString() + item.title;
	}
}
